import Button from '../../../components/Button';
import { useCallback, useState } from 'react';
import { postBrokerActivation } from '../../.././../../../services/integrationResources';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Notification from '../../../../../Utils/Notification';
import { selectUserInfo } from '../../../../../../store/selectors';
import { selectProduct } from '../../../../../../store/selectors/products';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { isValidNotificationUrl } from './helpers';

const Action = () => {
  // eslint-disable-next-line no-undef
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    data: { recommendationCode },
  } = useSelector(selectUserInfo);
  const {
    data: { isActive, name, notificationUrls },
  } = useSelector(selectProduct);
  const buttonActivationMessage = isActive ? 'Integration update' : 'Integration activate';

  const handleActivateIntegration = useCallback(async () => {
    setIsButtonDisabled((prev) => !prev);

    if (!isValidNotificationUrl(notificationUrls?.testNotificationUrl)
      || !isValidNotificationUrl(notificationUrls?.prodNotificationUrl)
    ) {
      Notification({
        type: 'error',
        text: formatMessage({
          id: 'Invalid notification URL.',
        }),
      }).show();

      setIsButtonDisabled((prev) => !prev);
      document.body.classList.remove('is-activating-integration');

      return;
    }

    const notificationActivationMessage = isActive ? 'Integration has been updated' : 'Integration has been activated';

    await postBrokerActivation(recommendationCode, {
      product: name,
      testNotificationUrl: notificationUrls?.testNotificationUrl === '' ? null : notificationUrls?.testNotificationUrl,
      prodNotificationUrl: notificationUrls?.prodNotificationUrl === '' ? null : notificationUrls?.prodNotificationUrl,
    })
      .then((response) => {
        dispatch({
          type: 'BROKER_PRODUCT_COMPLETED',
          payload: response,
        });

        Notification({
          type: 'success',
          text: formatMessage({ id: notificationActivationMessage }),
        }).show();

        setIsButtonDisabled((prev) => !prev);

        document.body.classList.remove('is-activating-integration');
      })
      .catch(() => {
        Notification({
          type: 'error',
          text: formatMessage({
            id: 'Something went wrong, try again later',
          }),
        }).show();

        document.body.classList.remove('is-activating-integration');
      });
  }, [notificationUrls?.testNotificationUrl, notificationUrls?.prodNotificationUrl]);

  useEffect(() => {
    const link = document.querySelectorAll('#activationLoading');

    link &&
      link.forEach((element) => {
        element.addEventListener('click', () => {
          document.body.classList.add('is-activating-integration');
        });
      });
  }, []);

  return (
    <div style={{ margin: '0 0 16px 0' }}>
      <Button
        id='activationLoading'
        isLoader
        label={buttonActivationMessage}
        iconLoader='refresh'
        type='error'
        onCallback={handleActivateIntegration}
        isDisabled={isButtonDisabled}
        isIconVisible={isActive}
        spin={isButtonDisabled}
        iconPlacement='right'
      />
    </div>
  );
};

export default Action;
